import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  /* background-color: blue; */
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
`;
